import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import CashierPage from 'modules/restaurant/cashier/CashierPage';

export default function DashRestaurantCashier() {
    return (
        <DashEstablishmentContainer title='Caixa'>
            <CashierPage />
        </DashEstablishmentContainer>
    );
}
